import { httpInterceptor } from './http.interceptor';
import { GetReceiptsDto, PaginatedReceiptsResponseDto } from '@/types/multinivel';

class MultinivelService {
  private baseUrl = '/multi-nivel';

  /**
   * Busca recibos multinível com paginação e filtros
   */
  async getReceipts(params: GetReceiptsDto = {}): Promise<PaginatedReceiptsResponseDto> {
    const queryParams = new URLSearchParams();

    const user = localStorage.getItem('userlogged');
    const email = user ? JSON.parse(user).email : null;

    
    // Adiciona parâmetros de paginação
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    
    // Adiciona filtros opcionais
    if (params.nome_beneficiaria) queryParams.append('nome_beneficiaria', params.nome_beneficiaria);
    if (params.nome_vendedora) queryParams.append('nome_vendedora', params.nome_vendedora);
    if (params.tipo) queryParams.append('tipo', params.tipo);
    if (params.mes_referencia) queryParams.append('mes_referencia', params.mes_referencia);
    if (params.valor_venda_min) queryParams.append('valor_venda_min', params.valor_venda_min.toString());
    if (params.valor_venda_max) queryParams.append('valor_venda_max', params.valor_venda_max.toString());
    if (params.nome_cliente) queryParams.append('nome_cliente', params.nome_cliente);
    if (params.code_pagarme) queryParams.append('code_pagarme', params.code_pagarme);

    const url = `${this.baseUrl}/admin/receipts${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await httpInterceptor.get(url);
    
    if (!response.ok) {
      throw new Error(`Erro ao buscar recibos: ${response.status}`);
    }

    return response.json();
  }

  /**
   * Busca um recibo específico por ID
   */
  async getReceiptById(id: number) {
    const response = await httpInterceptor.get(`${this.baseUrl}/receipts/${id}`);
    
    if (!response.ok) {
      throw new Error(`Erro ao buscar recibo: ${response.status}`);
    }

    return response.json();
  }

  /**
   * Busca estatísticas gerais dos recibos
   */
  async getReceiptsStats() {
    const response = await httpInterceptor.get(`${this.baseUrl}/receipts/stats`);
    
    if (!response.ok) {
      throw new Error(`Erro ao buscar estatísticas: ${response.status}`);
    }

    return response.json();
  }
}

export const multinivelService = new MultinivelService();
